export const allowOnlyCharactersAndNumbers = (cadena) => {
    return cadena.replace(/[^\w\s-+&@'.]/, "")
};
 export const phoneCharAllowed = (cadena) => {
    return cadena.replace(/[^0-9\s-+]/, "")
 }